var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonnel = function SvgPersonnel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.7c-2.9 0-5.2-2.4-5.2-5.3C6.8 2.4 9.1 0 12 0s5.2 2.4 5.2 5.3c0 3-2.3 5.4-5.2 5.4zm0-8.6c-1.7 0-3.1 1.4-3.1 3.2s1.4 3.2 3.1 3.2 3.1-1.4 3.1-3.2-1.4-3.2-3.1-3.2zM20.8 24c-.7 0-1.2-.5-1.2-1.2 0-4.6-3.4-8.3-7.6-8.3-4.2 0-7.6 3.7-7.6 8.3 0 .7-.5 1.2-1.2 1.2S2 23.5 2 22.8c0-5.9 4.5-10.7 10-10.7s10 4.8 10 10.7c0 .7-.5 1.2-1.2 1.2z"
  })));
};
export default SvgPersonnel;